import { render, staticRenderFns } from "./Evento.vue?vue&type=template&id=d001b988&scoped=true&"
import script from "./Evento.vue?vue&type=script&lang=js&"
export * from "./Evento.vue?vue&type=script&lang=js&"
import style0 from "./Evento.vue?vue&type=style&index=0&id=d001b988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d001b988",
  null
  
)

export default component.exports